import { useRef, useState } from "react";
import { sendReportReview } from "../../api/reportReviewApi";
import { useRuntimeConstants } from "../../context/runtimeConstants/RuntimeConstantsContext";

export const useReportReviews = (
  reviewId,
  onReportSuccess,
  reviewIsInModal
) => {
  const { getTranslation } = useRuntimeConstants();

  const [disabled, setDisabled] = useState(false);
  const [reportReviewText, setReportReviewText] = useState(() =>
    getTranslation("pdp_ratings_reviews_report_review")
  );

  const isReporting = useRef(false);

  const handleReportButtonClick = async () => {
    if (isReporting.current) return;

    isReporting.current = true;
    setDisabled(true);
    setReportReviewText(getTranslation("pdp_ratings_reviews_reported_review"));

    try {
      await sendReportReview(reviewId);
      onReportSuccess(reviewId, reviewIsInModal);
    } catch {
      setDisabled(false);
      setReportReviewText(getTranslation("pdp_ratings_reviews_report_review"));
    } finally {
      isReporting.current = false;
    }
  };

  return { handleReportButtonClick, disabled, reportReviewText };
};
